<template>
  <button
    class="pino-button"
    :class="{ 'pink-mode': isPink }"
    @click="$emit('toggle-pink')"
    @touchstart.stop
    aria-label="Toggle pink mode"
  >
    <span class="line">Pino</span>
    <span class="line">Button</span>
  </button>
</template>

<script>
export default {
  props: {
    isPink: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.pino-button {
  width: 140px;
  height: 140px;
  min-width: 44px;
  min-height: 44px;

  border-radius: 50%;
  background-color: hotpink; /* default (black bg) */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border: none;
  cursor: pointer;

  color: black;
  font-weight: 800;
  font-size: 1.2rem;
  line-height: 1.1;

  position: relative;

  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  touch-action: manipulation;
  user-select: none;

  /* PHYSICAL BUTTON */
  box-shadow:
    0 8px 0 #c2185b,
    0 12px 20px rgba(0, 0, 0, 0.35);

  transition:
    transform 0.1s ease,
    box-shadow 0.1s ease,
    background-color 0.15s ease,
    color 0.15s ease;
}

/* When background is pink → button is white */
.pino-button.pink-mode {
  background-color: white;
  color: black;

  box-shadow:
    0 8px 0 #bbb,
    0 12px 20px rgba(0, 0, 0, 0.35);
}

.pino-button:active {
  transform: translateY(6px);
  box-shadow:
    0 2px 0 rgba(0,0,0,0.2),
    0 6px 10px rgba(0, 0, 0, 0.25);
}

.line {
  pointer-events: none;
}
</style>
